<div *reloadComponent="FDN">
  <fr-isc-form *ngIf="FDN" Id="adapter" [ngClass]="mode === 'view' ? 'review-step' : null" [FDN]="FDN" [mode]="mode"
    [formModel]="formModel" [buttons]="mode === 'edit' ? buttons : null">
  </fr-isc-form>
  <p></p>
</div>
